import styled from 'styled-components';

export const FieldContainer = styled.div``;

export const FieldLabel = styled.label`
  ${({ theme: { font } }) => font.t3};
  display: block;
  margin-bottom: 4px;
`;

export const InputWrapper = styled.div`
  width: 100%;
`;
